export default __webpack_public_path__ + "media/bottom-bg.78e7afae.png";